import React, { FC, useState } from 'react'

import { EuiPanel, EuiLink, EuiFlexGroup, EuiFlexItem, EuiIcon, EuiSpacer, EuiButtonIcon, EuiBadge, EuiText } from '@elastic/eui'

import { Persona } from 'api/entities/Persona'

import PersonaDetails from './PersonaDetails'
import PersonaHeader from './PersonaHeader'

export interface PersonaCardProps {
  persona: Persona
  isExpanded: boolean
  onToggle: () => void
}

const PersonaCard: FC<PersonaCardProps> = ({ persona, isExpanded, onToggle }) => {
  return (
    <>
      <EuiPanel paddingSize='l'>
        <EuiFlexGroup>
          <EuiFlexItem grow={false} style={{ marginLeft: '-28px' }}>
            <EuiBadge
              style={{
                backgroundColor: '#f5f5f5',
                color: 'black',
                margin: 'auto',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.15)',
                fontWeight: 'bold',
                fontSize: '14px'
              }}>
              {persona.rank}
            </EuiBadge>
          </EuiFlexItem>
          <EuiFlexItem style={{ marginLeft: '1rem' }}>
            <EuiFlexGroup alignItems='center' justifyContent='spaceBetween' responsive={false}>
              <EuiFlexItem>
                <PersonaHeader persona={persona} />
              </EuiFlexItem>
            </EuiFlexGroup>

            <EuiSpacer size='m' />

            {isExpanded && <PersonaDetails persona={persona} />}
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiPanel>
    </>
  )
}

export default PersonaCard
